import script from "./canva_document.vue?vue&type=script&setup=true&lang=js"
export * from "./canva_document.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__